import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { IManufacturingCapabilities } from './capability.model';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'capabilities' })
export class CapabilityStore extends Store<IManufacturingCapabilities> {
  public constructor() {
    super({});
  }
}
